import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { ConfigService } from '../../services/config/config.service';


@Pipe({
  name: 'currencyFormatter',
  pure: false,
})
export class CurrencyFormatterPipe implements PipeTransform {

  constructor(private readonly configs: ConfigService) {}

  transform(value = 0, with_code: boolean = true): unknown {
    const currencyParam = this.configs.currencyData;

    let locale = "en", currency = this.configs.currency, currencyCode = this.configs.displayCurrency ?? currencyParam.strCode,
        digitsInfo = '1.' + currencyParam.intFractionsCount + "-" + currencyParam.intFractionsCount;

    const amount = formatCurrency(Number.parseFloat(value.toString()), locale, currency, currencyCode, digitsInfo).replace(/[^0-9\.,-]+/g, "");

    if(with_code){
      if(!currencyParam.bCodeAppendedEnd){
        return currencyParam.strCode.concat(currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' ') + amount;
      } else {
        return amount + (currencyParam.bAddCodeValueSeparator ? currencyParam.strCodeValueSeparator : ' ').concat(currencyParam.strCode);
      }
    }

    return amount;
  }

}
